<script setup>
import { computed } from 'vue';
import BaseAttachmentBubble from './BaseAttachment.vue';
import { useI18n } from 'vue-i18n';
import { useMessageContext } from '../provider.js';

const { attachments, contentAttributes } = useMessageContext();
const { t } = useI18n();

// SiteUp: duas fontes — anexo de localização (caminho nativo) ou o carimbo
// content_attributes.location extraído do texto espelhado do WAHA.
const location = computed(() => contentAttributes.value?.location ?? null);

const attachment = computed(() => {
  return attachments.value?.[0] ?? null;
});

const lat = computed(() => {
  return location.value?.latitude ?? attachment.value?.coordinatesLat;
});
const long = computed(() => {
  return location.value?.longitude ?? attachment.value?.coordinatesLong;
});

const title = computed(() => {
  return (
    location.value?.title ??
    attachment.value?.fallbackTitle ??
    attachment.value?.fallback_title
  );
});

const mapUrl = computed(
  () =>
    location.value?.mapUrl ??
    `https://maps.google.com/?q=${lat.value},${long.value}`
);
</script>

<template>
  <BaseAttachmentBubble
    icon="i-ph-navigation-arrow-fill"
    icon-bg-color="bg-[#0D9B8A]"
    sender-translation-key="CONVERSATION.SHARED_ATTACHMENT.LOCATION"
    :content="title"
    :action="{
      label: t('COMPONENTS.LOCATION_BUBBLE.SEE_ON_MAP'),
      href: mapUrl,
    }"
  />
</template>
